export const RESET_PRODUCT_SIZE = "RESET_PRODUCT_SIZE"
export const UPDATE_PRODUCT_SIZE_LIST = "UPDATE_PRODUCT_SIZE_LIST"
export const UPDATE_PRODUCT_SIZE_LIST_SUCCESS = "UPDATE_PRODUCT_SIZE_LIST_SUCCESS"
export const UPDATE_PRODUCT_SIZE_LIST_FAILED = "UPDATE_PRODUCT_SIZE_LIST_FAILED"
